//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import deleteReportFile from '~/graphql/mutations/deleteReportFile.gql';
import renameReportFile from '~/graphql/mutations/renameReportFile.gql';

export default {
  props: {
    image: {
      type: Object,
      default: () => {},
    },
    isBig: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isDeleted: false,
    editing: false,
    deleting: false,
    bigOpen: false,
  }),
  methods: {
    editName() {
      this.editing = true;
    },
    async deletePhoto() {
      try {
        await this.$apollo.mutate({
          mutation: deleteReportFile,
          variables: {
            id: this.image.id,
            report: this.$route.params.uuid,
          },
        }).then((data) => {
          if (data) {
            this.$toast.success('De foto is verwijderd.');
            this.isDeleted = true;
          } else {
            this.$toast.error('Er is iets fout gegaan met verwijderen van de foto');
          }
        });
      } catch (e) {
        this.$toast.error(e);
      }
    },
    async rename(newName) {
      this.editing = false;
      this.image.name = newName;
      try {
        await this.$apollo.mutate({
          mutation: renameReportFile,
          variables: {
            id: this.image.id,
            report: this.$route.params.uuid,
            name: this.image.name,
          },
        }).then((data) => {
          if (data) {
            this.$toast.success('De foto is bijgewerkt.');
          } else {
            this.$toast.error('Er is iets fout gegaan met bijwerken van de foto');
          }
        });
      } catch (e) {
        this.$toast.error(e);
      }
    },
  },
};
